import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { OscillometryAnalysisListScreen } from "./OscillometryAnalysisListScreen";
import { OscillometrySessionsListScreen } from "./OscillometrySessionsListScreen";
import { OscillometryAnalysisScreen } from "./OscillometryAnalysisScreen";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";

export const OscillometryRoot = () => {
    return (
        <Switch>
            <PrivateRoute path="/Oscillometry" exact permissions={[PermissionEnum.AccessSingleOscillometrySession, PermissionEnum.AccessAllOscillometrySessions, PermissionEnum.OverreadOscillometrySession]}>
                <OscillometrySessionsListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Oscillometry/Analysis" exact permissions={[PermissionEnum.OverreadOscillometrySession]}>
                <OscillometryAnalysisListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Oscillometry/Analysis/:analysisSetId/:viewState" permissions={[PermissionEnum.OverreadOscillometrySession, PermissionEnum.AccessSingleOscillometrySession]}>
                <OscillometryAnalysisScreen />
            </PrivateRoute>
        </Switch>
    );
}
